import React from 'react';
import { ArrowUpRight, Sparkles } from 'lucide-react';
import Reveal from './Reveal';

export default function Hero() {
  const handleClick = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="top" className="relative pt-36 md:pt-40 pb-24 md:pb-28 overflow-hidden">
      {/* soft warm gradient */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute -top-40 -left-32 w-[600px] h-[600px] rounded-full bg-gradient-to-br from-[#dbeafe] to-transparent blur-3xl opacity-70 drift" />
        <div className="absolute top-20 -right-32 w-[500px] h-[500px] rounded-full bg-gradient-to-bl from-[#e6f0fa] to-transparent blur-3xl opacity-60 drift-2" />
      </div>

      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-4xl">
          <Reveal variant="fade" delay={50}>
            <div className="inline-flex items-center gap-2 mb-8">
              <span className="w-8 h-px bg-[#1e6cb0]" />
              <span className="text-[12px] tracking-[0.2em] font-semibold text-[#1e6cb0] uppercase">
                Studio Biella Web &middot; Full-service
              </span>
            </div>
          </Reveal>

          <Reveal variant="up" delay={150} duration={900}>
            <h1 className="heading-mega text-[56px] sm:text-[78px] md:text-[100px] lg:text-[118px] text-neutral-900">
              Migliora<br />
              la tua azienda<br />
              con <span className="text-[#1e6cb0]">un click.</span>
            </h1>
          </Reveal>

          <Reveal variant="up" delay={350}>
            <div className="mt-10 flex flex-wrap items-center gap-4">
              <a
                href="https://wa.me/393383463712?text=Ciao!%20Ho%20visto%20il%20tuo%20sito%20B-WEB%20e%20vorrei%20avere%20informazioni%20per%20creare%20un%20sito%20web%20per%20la%20mia%20attivit%C3%A0."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-[#1e6cb0] text-white px-7 py-4 rounded-full font-semibold btn-glow"
              >
                Scrivimi su WhatsApp <ArrowUpRight className="w-4 h-4" />
              </a>
              <button
                onClick={() => handleClick('#come-funziona')}
                className="inline-flex items-center gap-2 bg-white border border-black/10 text-neutral-900 px-7 py-4 rounded-full font-semibold hover:border-black/30 transition-colors"
              >
                Come funziona
              </button>
            </div>
          </Reveal>

          <Reveal variant="fade" delay={500}>
            <p className="mt-8 text-[13px] text-neutral-500 flex items-center gap-2">
              <Sparkles className="w-3.5 h-3.5 text-[#1e6cb0]" />
              Accettiamo pochi progetti alla volta. Per restare bravi a farli.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
